module.exports = __webpack_public_path__ + "static/media/9_portrait.5fd9cdf9.jpg";